import { ConfigProviderProps } from "antd/lib/config-provider";

export const config: ConfigProviderProps = {
  componentSize: "large",
  theme: {
    token: {
      colorPrimary: "#2b8cee",
      colorLink: "#2b8cee",
      colorLinkHover: "#1e6bb8",
      colorFillSecondary: "#f5f5f5",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
    },
    components: {
      Radio: {
        colorPrimary: "#00b96b",
      },
      Select: {
        optionHeight: 10,
      },
    },
  },
};
